export * from './ubiContentTop.component';



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiContentTop/index.ts